<div class="row col-12 col-sm-12 my-account-container">
  <div class="col-3 col-sm-3 col-md-3 hidden-sm hidden-xs my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'MyCoresNavNode'"
    [childNavState]="'SearchCoreReturnNavNode'"></app-my-account-left-sidenav>
  </div>

  <div class="submit-warranty-claim col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
    <div class="my-section-box">

      @if (myCoreSearchData$|async; as myCoreSearchData) {
        <form [formGroup]="CoreSearchForm">
          <div class="warranty-claim-application-block">
            <h1 class="warranty-claim-headling m-0">
              {{'common.text_bendix_search_text4'|cxTranslate}}
            </h1>
            <div class="warranty-claim-application-detail">
              <p>
                {{'common.text_bendix_search_text5'|cxTranslate}}
              </p>
              <div class="warranty-customID-block na-ref-cust-info-box">
                <div class="fs-wrap">
                  <div class="fs-label-wrap">
                    <label class="control-label kbclass"
                    for="claimCustomerID">{{'common.text_warranty_search_customerID'|cxTranslate}}</label>
                    @for (data of myCoreSearchData?.b2bUnitsWSList; track data) {
                      @if (data.uid==defaultSoldTo) {
                        <div class="col-xs-12 col-sm-12 col-md-12 select-customer-id fs-label"
                          tabindex="0" (click)="showSearchResults($event)">
                          <input type="hidden" [value]="data.uid">
                          {{data?.salesArea1}}&nbsp;|&nbsp;
                          {{data?.salesArea2|cxTranslate}}&nbsp;|&nbsp;
                          {{data?.salesArea3}}
                        </div>
                        <img class="customerArrow" style="width: 20px"
                          (click)="showSearchResults($event)"
                          [src]="'/icons/arrow_down_blue.svg'" alt="">
                        }
                      }
                      @if (myCoreSearchData?.b2bUnitsWSList) {
                        <div class="warrentCustomerID">
                          @if (showCustomerList) {
                            <app-customer-id-drop-down
                              [customerId]="myCoreSearchData?.b2bUnitsWSList"
                              [pageSource]="'warrantyClaim'"
                            (dataEvent)="receiveData($event)"></app-customer-id-drop-down>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <div class="form-group">
                      <label class="control-label kbclass"
                      for="coreCustomerNo">{{'common.text_core_submit_customercrm'|cxTranslate}}</label>
                      <input id="coreCustomerNo" formControlName="coreCustomerNo" class="form-control"
                        type="text" value="">
                        @if (CoreSearchForm.get('coreCustomerNo').invalid && CoreSearchForm.get('coreCustomerNo').touched) {
                          <p
                          class="error-message">{{'common.general_required'|cxTranslate}}</p>
                        }
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                      <div class="form-group">
                        <label class="control-label kbclass"
                        for="ClaimDateFrom">{{'common.text_request_core_search_claim_from_date'|cxTranslate}}</label>
                        <input class="form-control kb-datePickerIcon warranty-datePicker"
                          formControlName="claimDateFrom" placeholder="mm/dd/yyyy" bsDatepicker
                          [maxDate]="EndDate" [(ngModel)]="FromDate"
                          [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY',showWeekNumbers:false, displayOneMonthRange: true }">
                          <div>
                            @if ( (this.Coreform.claimDateFrom.invalid && this.Coreform.claimDateFrom.touched)) {
                              <span class="text-danger-show"
                                >
                              {{'common.general_required'|cxTranslate}}</span>
                            }
                            @if (errorForGreaterStartDate) {
                              <span class="text-danger-show">
                              {{startDateErrorFromApi |cxTranslate}}</span>
                            }
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                        <div class="form-group">
                          <label class="control-label kbclass"
                          for="ClaimDateTo">{{'common.text_request_core_search_claim_to_date'|cxTranslate}}</label>
                          <input class="form-control kb-datePickerIcon warranty-datePicker"
                            formControlName="claimDateTo" placeholder="mm/dd/yyyy" bsDatepicker
                            [(ngModel)]="ToDate" [maxDate]="currentDate"
                            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY',showWeekNumbers:false, displayOneMonthRange: true }">
                            <div>
                              @if ( (this.Coreform.claimDateTo.invalid && this.Coreform.claimDateTo.touched)) {
                                <span class="text-danger-show"
                                  >
                                {{'common.general_required'|cxTranslate}}</span>
                              }
                              @if (errorForGreaterEndDate) {
                                <span class="text-danger-show">
                                  {{ endDateErrorFromApi |cxTranslate}}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-4">
                        <div class="col-xs-12 col-sm-6 showRequestCheckBox">
                          @if (myCoreSearchData?.coWorkerOrders) {
                            <div class="form-group">
                              <div class="checkbox">
                                <label>
                                  <input type="checkbox" formControlName="showRequestsFromCoworkers">
                                  {{'common.text_Show_core_of_coworkers'|cxTranslate}}
                                </label>
                              </div>
                            </div>
                          }
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 text-right core-search-btn-block">
                          <button type="button" id="WarrantyReset"
                            class="btn btn-default WarrantyReset blue-btn" name="WarrantyReset"
                          (click)="CoreSearchForm.reset()">{{'common.text_account_reset'|cxTranslate}}</button>
                          <button type="button" (click)="onSubmit()"
                            class="btn btn-primary yellow-btn warranty-submit"
                            id="finalSubmit">{{'common.text_account_search'|cxTranslate}} <img
                          class="img-hover" src="/icons/link-grey.svg" alt="Link Icon"></button>
                        </div>
                      </div>
                      <div class="mt-4">
                        <div class="core-contact" [innerHTML]="'common.text_core_search_contact'|cxTranslate">
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              }

            </div>
            <!-- Table -->

            <div class="warrantCount">
              @if (coreApiData?.pagination?.totalResults) {
                <span> {{ coreApiData?.pagination?.totalResults }}&nbsp;</span>
                {{'common.text_company_manageUser_registration_totalResults'|cxTranslate}}
              }
              @if (!coreApiData?.pagination?.totalResults) {
                {{'common.text_company_manageUser_registration_zeroResults'|cxTranslate}}
              }
            </div>
            <div class="coreTableOuter">
              <table class="table table-bordered table-blue order-status-table warrantySearchTable">
                <thead>
                  <tr>
                    <th scope="col DateTh"> <a class="a-underline " (click)="sort('crm');">
                      {{'common.text_core_search_CustomerCR'|cxTranslate}}
                      @if (sortByCRM== 'asc') {
                        &#8593;
                      }
                      @if (sortByCRM == 'desc') {
                        &#8595;
                      }
                    </a>
                  </th>

                  <th scope="col" class="warranty-search-refNo">
                    <a class="a-underline " (click)="sort('status')">
                      {{'common.text_core_search_CRStatus'|cxTranslate}}
                      @if (sortByStatus == 'asc') {
                        &#8593;
                      }
                      @if (sortByStatus == 'desc') {
                        &#8595;
                      }

                    </a>
                  </th>

                  <th scope="col" class="warranty-search-refNo">
                    <a class="a-underline" (click)="sort('date')">
                      {{'common.text_core_search_CreationDate'|cxTranslate}}
                      @if (sortByDate == 'asc') {
                        &#8593;
                      }
                      @if (sortByDate == 'desc') {
                        &#8595;
                      }
                    </a>
                  </th>

                  <th scope="col"> <a class="a-underline" (click)="sort('month')">
                    {{'common.text_core_search_CoreReturnMonth'|cxTranslate}}
                    @if (sortByMonth == 'asc') {
                      &#8593;
                    }
                    @if (sortByMonth == 'desc') {
                      &#8595;
                    }

                  </a>
                </th>

                <th scope="col"> <a class="">
                  {{'common.text_core_search_BOLStatus'|cxTranslate}}
                </a>
              </th>

              <th scope="col">
                <a class="">
                  {{'common.text_core_search_BOLPDF'|cxTranslate}}
                </a>
              </th>
            </tr>
          </thead>
          @if (coreApiData?.results) {
            <tbody>
              @for (item of coreApiData?.results; track item; let i = $index) {
                <tr class="responsive-table-item">
                  <td class="responsive-table-cell DateTh">
                    <span
                    class="d-lg-none core-search-label">{{'common.text_core_search_CustomerCR'|cxTranslate}}</span>
                    @if (!item?.billOfLadingPdf?.url&&!item?.coreMediaPdf?.url&&item?.status=='Saved (Not Submitted)') {
                      <a
                        [routerLink]="['/kbCoreSubmissionPage']" [queryParams]="{claimNo:item.crmNumber}"
                        class="cust-ref" (click)="getSavedCoreData(item.crmNumber)" download
                        target="_blank">
                        @if (item?.customerCRNumber) {
                          <span>{{item.customerCRNumber}}</span>
                        }
                        @if (!item?.customerCRNumber) {
                          <span>{{item.crmNumber}}</span>
                        }
                      </a>
                    }
                    @if (item?.coreMediaPdf?.url) {
                      <a [href]="baseUrl+item?.coreMediaPdf?.url" download
                        target="_blank">
                        @if (item?.customerCRNumber) {
                          <span>{{item.customerCRNumber}}</span>
                        }
                        @if (!item?.customerCRNumber) {
                          <span>{{item.crmNumber}}</span>
                        }
                      </a>
                    }
                    @if (!item?.coreMediaPdf?.url&&!item?.coreMediaPdf?.url&&item?.status!='Saved (Not Submitted)') {
                      <p
                        >
                        @if (item?.customerCRNumber) {
                          <span>{{item.customerCRNumber}}</span>
                        }
                        @if (!item?.customerCRNumber) {
                          <span>{{item.crmNumber}}</span>
                        }
                      </p>
                    }
                  </td>
                  <td class="responsive-table-cell">
                    <span
                    class="d-lg-none core-search-label">{{'common.text_core_search_CRStatus'|cxTranslate}}</span>
                    <span>{{ item.status }}</span>
                  </td>
                  <td class="responsive-table-cell">
                    <span
                    class="d-lg-none core-search-label">{{'common.text_core_search_CreationDate'|cxTranslate}}</span>
                    <span>{{ item.submitDate }}</span>
                  </td>
                  <td class="responsive-table-cell">
                    <span
                    class="d-lg-none core-search-label">{{'common.text_core_search_CoreReturnMonth'|cxTranslate}}</span>
                    <span>{{ item.coreMonth }}</span>
                  </td>
                  <td class="responsive-table-cell DateTh">
                    <span
                      class="d-lg-none core-search-label">{{'common.text_core_search_BOLStatus'|cxTranslate}}
                    </span>
                    <span>{{item?.billOfLading}}</span>
                  </td>
                  <td class="responsive-table-cell warranty-search-refNo">
                    <span class="d-lg-none core-search-label">
                      {{'common.text_core_search_BOLPDF'|cxTranslate}}
                    </span>
                    @if (item?.billOfLadingPdf?.url!=undefined) {
                      <a
                        [href]="baseUrl+item?.billOfLadingPdf?.url" download target="_blank">
                      <img class="imgSize" [src]="'/icons/pdf.svg'" alt="" /></a>
                    }
                    @if ((item?.billOfLadingPdf?.url==undefined) && (item?.billOfLading!=undefined)) {
                      <a
                        (click)="getBolPDf(item?.crmNumber,item?.billOfLading,$event,i)" class="a-underline"
                        download target="_blank">
                        @if (!isBolPdfAvailable[i]) {
                          <span>Request BOL</span>
                        }
                        @if (isBolPdfAvailable[i]) {
                          <img class="imgSize" [src]="'/icons/pdf.svg'" alt="" />
                        }
                      </a>
                    }
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>

        <!-- Pagination -->
        @if (coreApiData?.results) {
          <div class="account-orderhistory-pagination warranty-pagination">
            <div class="product__list--wrapper">
              <div class="pagination-bar">
                <div class="pagination-toolbar">
                  <div class="row sort-refine-bar">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 bottom-result">
                      <div class="pagination-result">
                        {{'common.search_page_showing_text'|cxTranslate}}
                        {{(coreApiData.pagination.pageSize *
                        coreApiData.pagination.currentPage)+1 }} -
                        @if (coreApiData.pagination.pageSize > coreApiData.pagination.totalResults) {
                          <span
                            >
                          {{coreApiData.pagination.totalResults}} </span>
                        }
                        @if ((coreApiData.pagination.pageSize *(coreApiData.pagination.currentPage+1) < coreApiData.pagination.totalResults)
                          &&(coreApiData.pagination.pageSize < coreApiData.pagination.totalResults)) {
                          <span>
                            {{coreApiData.pagination.pageSize*(coreApiData.pagination.currentPage+1)}}
                            {{'common.search_page_of_text'|cxTranslate}}
                          {{coreApiData.pagination.totalResults}} </span>
                        }
                        @if ((coreApiData.pagination.pageSize * (coreApiData.pagination.currentPage+1) > coreApiData.pagination.totalResults)
                          &&(coreApiData.pagination.pageSize < coreApiData.pagination.totalResults)) {
                          <span>
                            {{coreApiData.pagination.totalResults}}
                          of {{coreApiData.pagination.totalResults}} </span>
                        }
                        {{'common.search_page_result_text'|cxTranslate}}
                      </div>
                    </div>
                    <div
                      class="col-xs-12 col-sm-12 col-md-12 col-lg-6 kb-pagination-right kb-pagination">
                      <kb-pagination [pagination]="coreApiData?.pagination" [defaultPage]="0"
                        (viewPageEvent)="postCoreData($event)">
                      </kb-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

    </div>
  </div>
